export const API_URL = "/api/";
export const HOSTNAME = "forms.test/";
// export const HOSTNAME = "formularios.inmore.cl/";
